import { render } from "./AsArticleCard.vue?vue&type=template&id=3f21aa62&scoped=true&ts=true"
import script from "./AsArticleCard.vue?vue&type=script&lang=ts"
export * from "./AsArticleCard.vue?vue&type=script&lang=ts"

import "./AsArticleCard.vue?vue&type=style&index=0&id=3f21aa62&lang=scss&scoped=true"
import "./AsArticleCard.vue?vue&type=style&index=1&id=3f21aa62&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f21aa62"]])

export default __exports__